import React from 'react'
import { motion, animate } from "motion/react"
import about from '../../../assets/images/about.png'
const sectionReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: 'easeOut' },
  viewport: { once: true, amount: 0.2 },
}

export default function About() {
  return (
    <motion.section {...sectionReveal} className="bg-[#FFF] py-16 md:px-12 px-4 flex flex-wrap justify-between">
      <div className='md:w-[48%] w-full'>
        <p className="md:text-4xl text-2xl text-center font-semibold text-sky-700 md:mb-12 mb-6">عن الملتقى</p>
        <div
          dir="rtl"
          className="
            md:space-y-6
            lg:text-3xl
            text-sm
            leading-loose
            text-slate-800
            mb-6 md:mb-0
            text-justify
          "
        >
  <p>يركــز الملتقــى علـــــى بنــاء القــدرات، وتعزيـــــز ثقافــة التدريــب
              والتطويــر، والتوســـــع فــي تقديــم البرامــج التــي تلبــي احتياجــات
              ســـــوق العمــل، بمــا يســاهم فــي تحقيــق مســتهدفات برنامــج
              تنميــة القــدرات البشــرية، أحـــــد برامــج الرؤيــة 2030 . يتخلــل
              الملتقــى جلســات حواريــة وورش عمــل تخصصيــة، إلـــــى جانــب
              عــرض مبــادرات نوعيـــــة. تتزامــن معــه إقامــة معـــــرض نوعــي
              لتعزيـز فـرص التعــــاون فـي التدريـب وبنـاء الشـراكات النوعيـة.</p>
        </div>
      </div>
      <div className='md:w-[48%] w-full'>
        <img src={about} alt="about" className="w-[80%] md:mr-auto mx-auto h-full object-cover" />
      </div>
    </motion.section>
  )
}